export const uk = {
    'minus-phrase-list': 'Минус-фразы'
};
